import { makeStyles } from 'tss-react/mui';

const useStylesLocationMap: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  locationMap: {
    height: 305,
    marginTop: 8,
    width: '100% !important',
    '& a': {
      color: `${theme.palette.secondary.main} !important`,
    },
  },
}));

export default useStylesLocationMap;
